export const JSON_SCHEMA_DOCS_URL =
  'https://platform.openai.com/docs/guides/structured-outputs#all-fields-must-be-required'
